import { Box, SpacerNew, TextNew } from '@jfs/ui-new';
import { useNavigation, useRoute } from '@react-navigation/core';
import { useEffect, useState } from 'react';
import { InteractionManager, Keyboard } from 'react-native';
import { AepsButton } from '../../../comps/AepsButton';
import { Container } from '../../../comps/Container';
import { FormTitle } from '../../../comps/FormTitle';
import { DeleteBeneficiaryOtp } from '../../../comps/OtpTextInputWithTimer/DeleteOtpWithTimer';
import { useStores } from '../../../data/store';

export const DeleteBeneficiaryVerifyScreen = () => {
    const navigation = useNavigation();
    const route = useRoute<any>();
    const { selectedBene, remitterMobile } = route.params;

    const [otp, setOtp] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setOtp('');
    }, [selectedBene]);

    const { messageStore, verifyDeletionOtp, deleteBeneficiary, sendOtpBeniDelete, getBeneficiaryListData } = useStores((store) => ({
        messageStore: store.message,
        verifyDeletionOtp: store.moneyTransferSession.verifyDeletionOtp,
        deleteBeneficiary: store.beneficiaryDetails.deleteBeneficiary,
        sendOtpBeniDelete: store.moneyTransferSession.sendOtpBeniDelete,
        getBeneficiaryListData: store.beneficiaryDetails.getBeneficiaryListData
    }));

    const onVerifyOtp = async (enteredOtp: string) => {
        Keyboard.dismiss();
        setLoading(true);
        InteractionManager.runAfterInteractions(async () => {
            try {
                const apiResponse = await verifyDeletionOtp(enteredOtp, remitterMobile, { mode: 33, purpose: 19 });
                if (apiResponse?.status === 'SUCCESS') {
                    const payload = {
                        updatedBy: "USER",
                        beneId: selectedBene?.beneId,
                        authCode: apiResponse.authorizationCode,
                        remittanceUserId: apiResponse.remittanceUserId,
                        mobile: remitterMobile,
                    };
                    const deleteRes = await deleteBeneficiary(payload);
                    if (deleteRes?.status === "SUCCESS") {
                        messageStore.setMessage("Beneficiary deleted successfully.", 'POSITIVE', 'BOTTOM');
                        // await getBeneficiaryListData();
                        navigation.goBack();
                    }
                }
            } catch (err) {
                console.error("Delete failed", err);
            } finally {
                setLoading(false);
            }
        });
    };

    // useFocusEffect(
    //     useCallback(() => {
    //         getBeneficiaryListData();
    //     }, [getBeneficiaryListData])
    // );

    const handleResendOtp = () => {
        setOtp('');
        sendOtpBeniDelete(remitterMobile, { mode: 33, purpose: 19 });
    };

    return (
        <Container type="default" showFooter={true}>
            <Box backgroundColor="WHITE">
                <FormTitle title={"Verify Deletion"} />
                <SpacerNew size={24} />
                {/* <TextNew title="Verify Deletion" fontSize={18} family="bold" /> */}
                <TextNew title="Please verify the beneficiary details before deleting" color="BRAND_COLOR_GRAY_2" />
                <SpacerNew size={24} />
                <Box backgroundColor="#F9F9F9" padding={16} borderRadius={12} borderWidth={1} borderColor="#EEE">
                    <Box flexDirection="row" justifyContent="space-between" marginBottom={8}>
                        <TextNew title="Beneficiary Name" fontSize={13} color="BRAND_COLOR_GRAY_2" />
                        <TextNew title={selectedBene?.beneAccountHolderName} fontSize={13} family="medium" color="PRIMARY" />
                    </Box>
                    <Box flexDirection="row" justifyContent="space-between" marginBottom={8}>
                        <TextNew title="Account Number" fontSize={13} color="BRAND_COLOR_GRAY_2" />
                        <TextNew title={selectedBene?.beneAccountNumber} fontSize={13} family="medium" color="PRIMARY" />
                    </Box>
                    <Box flexDirection="row" justifyContent="space-between">
                        <TextNew title="IFSC Code" fontSize={13} color="BRAND_COLOR_GRAY_2" />
                        <TextNew title={selectedBene?.beneIfscCode?.toUpperCase()} fontSize={13} family="medium" color="PRIMARY" />
                    </Box>
                </Box>

                <SpacerNew size={32} />
                <DeleteBeneficiaryOtp
                    mobileNumber={remitterMobile}
                    value={otp}
                    onChangeText={setOtp}
                    onOtpComplete={onVerifyOtp}
                    onResendOtpButtonPress={handleResendOtp}
                    isModalOpen={true}
                    mode={33}
                    purpose={19}
                />

                <SpacerNew size={24} />

                <AepsButton
                    title="Verify & Delete"
                    onPress={() => onVerifyOtp(otp)}
                    isLoading={loading}
                    disabled={otp.length !== 6}
                />
            </Box>
        </Container>
    );
}